import { StaffMember } from "@interfaces/StaffMember";
import { Avatar, Button, Fade, Menu, MenuItem } from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";
import React, { useState } from "react";

interface Props {
    user: StaffMember;
    onLogout(): void;
    onRedirectToCabinet(): void;
}

const UserMenuButton = ({ user, onLogout, onRedirectToCabinet }: Props) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <>
            <Button
                endIcon={<ArrowDropDown />}
                onClick={handleMenuOpen}
                color="inherit"
                startIcon={<Avatar alt="user">{user.login.charAt(0)}</Avatar>}
            >
                {user.login}
            </Button>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={!!anchorEl}
                onClose={handleClose}
                TransitionComponent={Fade}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem
                    onClick={() => {
                        onRedirectToCabinet();
                        handleClose();
                    }}
                >
                    Личный кабинет
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        onLogout();
                        handleClose();
                    }}
                >
                    Выйти
                </MenuItem>
            </Menu>
        </>
    );
};

export default UserMenuButton;
